<template>
  <div class="modern-loader-wrap">
    <svg class="modern-loader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <circle class="modern-loader-track" cx="12" cy="12" r="9" stroke="currentColor" stroke-width="3" />
      <path class="modern-loader-head" d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
    </svg>
  </div>
</template>

<style scoped>
.modern-loader-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4f46e5;
}

.modern-loader {
  width: 28px;
  height: 28px;
  animation: modernSpin 0.8s linear infinite;
}

.modern-loader-track {
  opacity: 0.15;
}

.modern-loader-head {
  opacity: 0.9;
}

@keyframes modernSpin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>























